import * as React from "react";
import Dropdown from "../Dropdown/Dropdown";
import Input from "../Input-new/Input";
import Textarea from "../Textarea-new/Textarea";

const VendorInfo = ({
  data,
  handleChangeInput,
  handleChangeDropdown,
  isExists,
  viewMode,
  deleted,
  handleParentDropdownChange,
  typeDuplicate
}) => {
  return (
    <div className="Buyer-info">
      <div className="Buyer-info_column">
      {(isExists) && <p className="errorText">{typeDuplicate ? typeDuplicate : " Given Vendor Details Already Exists"}</p>}
      <Dropdown
          className="Vendor-info_column_item"
          data={data}
          optionsType="vendorType"
          value={data.vendor_type}
          valueKey="vendor_type"
          label="Vendor Type"
          handleParentChange={handleChangeDropdown}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Input
          className="Buyer-info_column_item"
          required
          valueType="text"
          name="first_name"
          label="First Name"
          value={data.first_name}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Input
          className="Buyer-info_column_item"
          required
          valueType="text"
          name="last_name"
          label="Last Name"
          value={data.last_name}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Input
          className="Buyer-info_column_item"
          required={data.contact_type && data.contact_type.includes("Team")}
          valueType="phone"
          name="phone"
          label="Work Phone"
          value={data.phone}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Input
          className="Buyer-info_column_item"
          required={data.contact_type && data.contact_type.includes("Team")}
          valueType="phone"
          name="cell_phone"
          label="Cell Phone"
          value={data.cell_phone}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
        <Input
          className="Buyer-info_column_item"
          required={data.contact_type && data.contact_type.includes("Team")}
          valueType="email"
          name="email"
          label="Email"
          value={data.email}
          handleParentChange={handleChangeInput}
          viewMode={viewMode}
          deleted={deleted}
        />
          <Dropdown
          className="Buyer-info_column_item"
          dropdownType='multiple'
          optionsType='contactType'
          value={Array.isArray(data.contact_type) ? data.contact_type.join(",") : data.contact_type || ""}
          valueKey='contact_type'
          label='Contact Type'
          data={data}
          handleParentChange={handleParentDropdownChange}
          viewMode={viewMode}
        />
        {data.contact_type && (data.contact_type.includes("Lender")) ?
          <Input
            className="Buyer-info_column_item"
            name="name"
            required
            label="Company"
            value={data.name}
            handleParentChange={handleChangeInput}
            viewMode={viewMode}
            deleted={deleted}
          />
          : ""
        }
        {/* {data.contact_type && (data.contact_type.includes("Lender")) ? */}
          {/* <Textarea
            className="Buyer-info_column_item"
            required = {data.contact_type && (data.contact_type.includes("Lender"))}
            valueType="text"
            inputType="textarea"
            name="notes"
            label="Notes"
            value={data.notes}
            maxWidth="100%"
            viewMode={viewMode}
            handleParentChange={handleChangeInput}
            deleted={deleted}
          />  */}
        {/* } */}

      </div>
    </div>
  );
};

export default VendorInfo;
